export default __webpack_public_path__ + "static/media/client03.3d14319b.jpg";